import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { HTTPStatusCode } from '@as-react/common-types';
import { getHomepageUrl } from '@as-react/common-utils';
import { Box, TextAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { isAxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomerApi from '../../api/customer/CustomerApi';
import { PasswordResetForm, PasswordResetFormView, } from '../../components/password-reset-form/PasswordResetForm';
import { DELAY } from '../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { getQuerystringByName } from '../../util/URLParamUtil';
const EVENT_PARAM_KEY = 'event';
const AccountActivationContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint, root } = useAemConfig();
    const isMobile = useMediaQueryMatchesOnMobile();
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.buy]);
    const [customerUUID, setCustomerUUID] = useState('');
    const [isValidUUID, setIsValidUUID] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const [buttonState, setButtonState] = useState('interactive');
    const [isSuccess, setIsSuccess] = useState(false);
    const [errorFeedback, setErrorFeedback] = useState('');
    const onSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        setButtonState('loading');
        try {
            if (isValidUUID) {
                yield CustomerApi.resetPassword(servicesEndpoint, defaultRequestParams, customerUUID, values.password);
                setIsSuccess(true);
                setButtonState('interactive');
                setErrorFeedback('');
                setTimeout(() => (window.location.href = getHomepageUrl(root)), DELAY.DELAY_3000);
            }
            else {
                const result = yield CustomerApi.emailExists(servicesEndpoint, defaultRequestParams, values.email, true);
                if (result.knownForFascia) {
                    setErrorFeedback(t('account:account.activation.already.exists'));
                    setButtonState('interactive');
                }
                else if (result.hasIdentity && !result.knownForFascia) {
                    setErrorFeedback('');
                    setIsSuccess(true);
                    setButtonState('interactive');
                }
                else {
                    setErrorFeedback(t('account:account.activation.register'));
                    setButtonState('interactive');
                }
            }
        }
        catch (error) {
            if (isAxiosError(error)) {
                if (!isValidUUID && error.response.status === HTTPStatusCode.BadRequest) {
                    setErrorFeedback(t('account:account.activation.email.unknown'));
                }
                setButtonState('interactive');
            }
        }
    });
    useEffect(() => {
        var _a;
        const validateUUID = (uuid) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield CustomerApi.validatePasswordResetLink(servicesEndpoint, defaultRequestParams, uuid);
                setIsValidUUID(true);
            }
            catch (_a) { }
            setShouldRender(true);
        });
        const uuid = (_a = getQuerystringByName(window.location.search, EVENT_PARAM_KEY)) !== null && _a !== void 0 ? _a : '';
        setCustomerUUID(uuid);
        validateUUID(uuid);
    }, []);
    return shouldRender ? (_jsx(Box, { paddingBlockEnd: {
            base: '10',
            md: '12',
            lg: '14',
        }, paddingBlockStart: {
            base: '6',
            md: '7',
        }, children: _jsxs(Box, { backgroundColor: "quiet", shadow: !isMobile ? 'lg' : undefined, paddingBlockStart: {
                base: '6',
                md: '10',
            }, paddingBlockEnd: {
                base: '4',
                md: '6',
                lg: '12',
            }, paddingInline: {
                base: '4',
                md: '12',
            }, marginInline: { base: '-4', md: '0' }, children: [isValidUUID ? (_jsx(_Fragment, { children: title.show && (_jsx(Box, { paddingBlockEnd: { base: '4', md: '8' }, children: _jsx(TextAlpha, { as: "h2", variant: "subheadingXL", children: title.value || t('account:account.password.passwordOne') }) })) })) : (_jsxs(_Fragment, { children: [_jsx(TextAlpha, { as: "h2", variant: "subheadingS", children: t('account:account.activation.invalidToken') }), _jsx(Box, { paddingBlockStart: "3", paddingBlockEnd: "6", children: _jsx(TextAlpha, { as: "p", variant: "bodyS", children: t('account:account.activation.tryAgain') }) })] })), _jsx(PasswordResetForm, { onSubmit: onSubmit, view: isValidUUID ? PasswordResetFormView.DEFAULT : PasswordResetFormView.EMAIL, buttonState: buttonState, isSuccess: isSuccess, errorFeedback: errorFeedback, buttonText: isValidUUID ? t('account:account.activation.confirm') : null, buttonFinisherText: isValidUUID ? t('account:account.activation.activated') : null })] }) })) : null;
};
export default AccountActivationContainer;
